<template>
  <div class="form-group">
    <p class="font-weight-bold">{{ text }}</p>
    <div class="mb-4">
      <div v-if="invalid" class="text-primary mt-n2 mb-1">{{ $t('SurveyPage.answerIsRequired') }}</div>
      <div class="d-flex justify-content-between small font-weight-bold mb-n3">
        <div>{{ labelMin }}</div>
        <div :class="{'text-primary': (max.value === internalValue)}">{{ labelMax }}</div>
      </div>
      <form>
        <div class="form-group mx-n2 mb-0">
          <label :for="'question-' + id" class="sr-only">Select score</label>
          <input :id="'question-' + id" v-if="min.value < max.value" type="range" v-model="internalValue"
                 :min="min.value" :max="max.value" :step="step" class="custom-range custom-range-scale"
                 :class="{'custom-range-scale-hide': (internalValue === undefined)}"
                 @input="input" @click="click">
        </div>
      </form>
      <ul class="range-label-steps d-flex align-items-center justify-content-between text-muted p-0 small mt-n3 mx-n2">
        <li :class="{'selected': (i.value === internalValue)}" v-for="i in this.options" :key="i.value">{{
            i.value
          }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>

export default {
  name: 'QuestionRadio',
  data() {
    return {
      internalValue: undefined
    }
  },
  props: ['question', 'value', 'invalid'],
  computed: {
    id() {
      return this.question.id
    },
    options() {
      return this.question.options
    },
    text() {
      return this.question.text
    },
    step() {
      return this.options[1].value - this.options[0].value
    },
    min() {
      return this.options[0]
    },
    max() {
      return this.options[this.options.length - 1]
    },
    labelMin() {
      return this.min.label
    },
    labelMax() {
      return this.max.label
    }
  },
  methods: {
    click(event) {
      if (this.internalValue === undefined) {
        this.internalValue = event.target.value
        this.input(event)
      }
    },
    input(event) {
      this.$emit('update:value', event.target.value)
    }
  }
}
</script>
